const features = [
  {
    icon: 'ri-flashlight-line',
    title: '秒开不缓冲',
    desc: '全球CDN加速节点覆盖，智能预加载技术确保点击即播，告别转圈等待，4K影视也能流畅播放。',
  },
  {
    icon: 'ri-4k-line',
    title: '4K超清蓝光',
    desc: '从高清到超清，从蓝光到4K，多档清晰度随心切换，自适应码率技术兼顾画质与流畅度。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '全设备适配',
    desc: '电脑、平板、手机完美兼容的响应式界面，在任何屏幕上都能获得舒适的观影布局。',
  },
  {
    icon: 'ri-database-2-line',
    title: '海量片库日更',
    desc: '超过10万部电影大全，每日凌晨自动更新最新电影、热门电影排行榜与华语电影资源。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全无广告',
    desc: '纯净观影环境，无弹窗、无强制广告、无恶意跳转，保护您的隐私和设备安全。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2">
          <span className="w-2 h-6 md:h-7 rounded-full bg-primary-500"></span>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-50">为什么选择我们</h2>
        </div>
        <p className="text-sm text-foreground-400 mb-8 md:mb-10">五大核心优势，打造至臻观影体验</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3 md:gap-4">
          {features.map((item, i) => (
            <div
              key={i}
              className="p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/40 hover:border-primary-500/20 transition-all group cursor-default"
            >
              <span className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-xl bg-primary-500/10 mb-4 group-hover:bg-primary-500/20 transition-colors">
                <i className={`${item.icon} text-primary-400 text-xl`}></i>
              </span>
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-50 mb-2">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-300 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}